module.exports = __webpack_public_path__ + "static/media/slide3.4a3190c0.jpg";